
export default {
    name: 'AutoDownloadCheckbox',
    data: () => ({
        autoSaveToCloud: false
    }),
    computed: {
        autoSaveToDrive() { return this.$store.state.autoSaveToDrive }
    },
    watch: {
        autoSaveToDrive(val) {
            this.autoSaveToCloud = val
        }
    },
    created () {
        this.$store.commit('setAutoSaveToDrive', true)
        this.autoSaveToCloud = true
    },
    methods: {
        onChange() {
            this.$store.commit('setAutoSaveToDrive', this.autoSaveToCloud)
        }
    }
}
